module.exports = "<div style=\"top: 50vh;left: 50vw;position: absolute;text-align: center; margin-left:-25px\">\r\n    <mat-spinner [diameter]=\"50\" style=\"margin: 0 auto\"></mat-spinner>\r\n</div>\r\n<div class=\"ip-calc-space\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/portal-logout-view/portal-logout-view.component.html
// module id = ./src/app/views/portal-logout-view/portal-logout-view.component.html
// module chunks = main